module.exports = __webpack_public_path__ + "static/media/013.385f7521.jpg";